import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

// 인쇄(및 브라우저의 'PDF로 저장')용 문서를 body 바로 아래에 그려 window.print()를 연다.
// 인쇄 중에는 Finance.scss의 @media print 규칙이 이 영역만 보이게 한다. 인쇄 창이 닫히면 onDone.
export default function PrintPortal({ children, onDone, title }: { children: ReactNode; onDone: () => void; title?: string }) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title; // PDF로 저장할 때 기본 파일 이름이 된다
    document.body.classList.add('fin-printing');
    const finish = () => {
      document.body.classList.remove('fin-printing');
      document.title = previousTitle;
      onDone();
    };
    window.addEventListener('afterprint', finish, { once: true });
    const t = window.setTimeout(() => window.print(), 100);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener('afterprint', finish);
      document.body.classList.remove('fin-printing');
      document.title = previousTitle;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return createPortal(<div className="fin-print-root">{children}</div>, document.body);
}
